/* jslint nomen: true */

'use strict';

const $ = require('jquery');

import {debounce} from '../components/custom-lodash';
import {NewsletterPopup, COOKIE_NAME as NEWSLETTER_POPUP_SHOWN} from '../flyins/newsletterpopup';

let initialized = false;
const $body = $('body');
const $window = $(window);
const NEWSLETTER_SHOW_PERCENT = 30;

const scrolledpage = {
    /**
     * @function
     * @description
     * @param {string} page - The page name (homepage, pdp and etc.)
     */
    init: function (page) {
        let handleScroll;
        let newsletterShow = false;
        let lastHeight = 0;
        let scrollSpeed = 0;

        if (!initialized) {
            handleScroll = function () {
                const currentHeight = $window.scrollTop();
                const documentHeight = $(document).height();
                const windowHeight = $(window).height();
                const halfPageHeight = (documentHeight - windowHeight) / 2;
                const scrollPercent = (currentHeight / (documentHeight - windowHeight)) * 100;

                scrollSpeed = currentHeight - lastHeight;

                // exit intent on mobile, fast scroll to top
                if (
                    scrollSpeed < -1000 &&
                    currentHeight <= 0 &&
                    lastHeight !== 0 &&
                    !newsletterShow &&
                    (page === 'clp' || page === 'pdp')
                ) {
                    NewsletterPopup.initOnFastScroll();
                    newsletterShow = true;
                }
                lastHeight = currentHeight;

                if (
                    page === 'homepage' &&
                    document.cookie.indexOf(NEWSLETTER_POPUP_SHOWN) === -1 &&
                    SitePreferences.NEWSLETTER_POPUP_ENABLED &&
                    scrollPercent > NEWSLETTER_SHOW_PERCENT &&
                    !newsletterShow
                ) {
                    NewsletterPopup.initHomepage();
                    newsletterShow = true;
                }

                if (currentHeight >= halfPageHeight) {
                    $body.addClass('half-page-scrolled');
                    $('.ebcss-chat-button').addClass('ebcss-chat-button-repositioned');
                } else {
                    $body.removeClass('half-page-scrolled');
                    $('.ebcss-chat-button').removeClass('ebcss-chat-button-repositioned');
                }

                $body[(currentHeight > 0 ? 'add' : 'remove') + 'Class']('scroll');
            };

            $window.on('scroll', debounce(handleScroll, 50));
            handleScroll();
            initialized = true;
        }
    }
};

module.exports = scrolledpage;
